export const API_PATH_ApiTrafficStudyHistorySearchGet = '/services/traffic-studies/apiTrafficStudyHistorySearchGet';
